module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/store_images/1_a98a44ad62b5a8138ae049e122a5f86a.png";